import { Link } from 'react-router-dom';
import { testimonials } from '@/mocks/articles';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function AboutPage() {
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'http://91miaozan.com/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '关于我们',
        item: 'http://91miaozan.com/about',
      },
    ],
  };

  const aboutPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于爆瓜网',
    description: '爆瓜网是国内领先的娱乐八卦爆料资讯平台，致力于为广大吃瓜群众提供最新、最全、最真实的网红反差爆料与娱乐内幕资讯。',
    url: 'http://91miaozan.com/about',
    mainEntity: {
      '@type': 'Organization',
      name: '爆瓜网',
      url: 'http://91miaozan.com/',
      description: '爆瓜网聚焦吃瓜网爆料在线社区，带来网红反差真实爆料与劲爆内容',
      email: 'hello@91miaozan.com',
      telephone: '400-888-6666',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '望京SOHO T3 18层',
        addressLocality: '北京',
        addressRegion: '朝阳区',
        addressCountry: 'CN',
      },
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '爆瓜网的内容真实吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '爆瓜网所有内容均经过编辑团队的多方核实，我们坚持「不编造、不夸大」的报道原则，力求为读者呈现最真实、最有价值的娱乐资讯。',
        },
      },
      {
        '@type': 'Question',
        name: '如何向爆瓜网投稿爆料？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过页面底部的联系表单向我们提交爆料线索，也可以通过邮箱 hello@91miaozan.com 发送详细信息。我们会第一时间对线索进行核实和跟进。',
        },
      },
      {
        '@type': 'Question',
        name: '爆瓜网的内容多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '爆瓜网实行7×24小时全天候更新机制，日均内容更新量超过50篇，确保读者每天都能获取最新的吃瓜资讯。',
        },
      },
      {
        '@type': 'Question',
        name: '爆瓜网覆盖哪些内容领域？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们覆盖六大核心领域：网红反差、明星八卦、独家揭秘、劲爆内幕、吃瓜社区和每日实时，全方位满足你的吃瓜需求。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutPageSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <main className="min-h-screen bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 pt-24 pb-14">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="mt-8 mb-16">
            <h1 className="text-3xl md:text-5xl font-bold font-heading text-foreground-950 mb-6">
              关于<span className="text-primary-500">爆瓜网</span>
            </h1>
            <div className="max-w-3xl">
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
                爆瓜网成立于2024年，是国内领先的娱乐八卦爆料资讯平台。我们致力于为广大吃瓜群众提供最新、最全、最真实的网红反差爆料与娱乐内幕资讯。无论是网红圈的真实面目，还是娱乐圈的深水炸弹，爆瓜网都为你一网打尽。
              </p>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
                我们的编辑团队由资深娱乐记者、新媒体运营专家和数据分析师组成，拥有丰富的行业经验和敏锐的新闻嗅觉。我们坚持「不编造、不夸大、有态度」的报道原则，力求为每一位读者呈现最真实、最有价值的内容。
              </p>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                目前，爆瓜网月活跃用户已突破500万，日均内容更新量超过50篇，已成为中文互联网最具影响力的吃瓜社区之一。
              </p>
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-8">
              品牌<span className="text-primary-500">理念</span>
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                { icon: 'ri-shield-check-line', title: '真实可靠', desc: '每一条爆料都经过多方核实，拒绝虚假新闻和标题党' },
                { icon: 'ri-flashlight-line', title: '快速及时', desc: '7×24小时全天候监控，第一时间为你带来最新爆料' },
                { icon: 'ri-user-voice-line', title: '用户至上', desc: '以吃瓜群众视角出发，做最懂你的娱乐资讯平台' },
                { icon: 'ri-scales-line', title: '客观公正', desc: '不偏袒任何一方，坚持客观中立的报道立场' },
              ].map((item, index) => (
                <div key={index} className="bg-background-100 rounded-xl p-6">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4">
                    <i className={`${item.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-foreground-950 font-semibold text-sm mb-2">{item.title}</h3>
                  <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-8">
              用户<span className="text-primary-500">口碑</span>
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {testimonials.map((t) => (
                <div key={t.id} className="bg-background-100 rounded-xl p-6">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-sm ${i < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                    「{t.comment}」
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-secondary-200 flex items-center justify-center">
                      <i className="ri-user-line text-secondary-600 text-sm"></i>
                    </div>
                    <span className="text-foreground-800 text-sm font-medium whitespace-nowrap">{t.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-16 bg-background-100 rounded-2xl p-8 md:p-12">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-8">
              联系<span className="text-primary-500">我们</span>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-foreground-800 font-semibold text-sm mb-4">商务合作 / 内容投稿</h3>
                <div className="space-y-3">
                  <div className="flex items-center gap-3 text-foreground-600 text-sm">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-mail-line"></i>
                    </div>
                    <span>hello@91miaozan.com</span>
                  </div>
                  <div className="flex items-center gap-3 text-foreground-600 text-sm">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-phone-line"></i>
                    </div>
                    <span>400-888-6666</span>
                  </div>
                  <div className="flex items-center gap-3 text-foreground-600 text-sm">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-map-pin-line"></i>
                    </div>
                    <span>北京市朝阳区望京SOHO T3 18层</span>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-foreground-800 font-semibold text-sm mb-4">给我们留言</h3>
                <form
                  className="space-y-3"
                  data-readdy-form="true"
                  action="https://readdy.ai/api/form/d92flno0sqa2sn3dng30"
                  method="POST"
                >
                  <input
                    type="text"
                    name="name"
                    placeholder="您的姓名"
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-foreground-800 placeholder:text-foreground-400 text-sm outline-none focus:border-primary-300 transition-colors duration-200"
                    required
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="您的邮箱"
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-foreground-800 placeholder:text-foreground-400 text-sm outline-none focus:border-primary-300 transition-colors duration-200"
                    required
                  />
                  <textarea
                    name="message"
                    placeholder="请输入您的留言（500字以内）"
                    rows={3}
                    maxLength={500}
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-foreground-800 placeholder:text-foreground-400 text-sm outline-none focus:border-primary-300 transition-colors duration-200 resize-none"
                    required
                  ></textarea>
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    className="honeypot-field"
                  />
                  <button
                    type="submit"
                    className="w-full px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors duration-200"
                  >
                    发送留言
                  </button>
                </form>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
}